import { Button, Chip, CircularProgress, Grid, IconButton, Paper, Typography } from "@material-ui/core";
import jMoment from "moment-jalaali";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { useFetch } from "../../features/customHooks/useFetch";
import { useStyles } from "./valuationHistory.styles";
import { OpenInBrowserOutlined } from "@material-ui/icons";

const ValuationHistory = (props) => {
  const classes = useStyles();
  const { postalCode } = props;

  const initialParams = {
    method: "get",
    url: "/valuation/history/" + postalCode,
  };
  const [getFetchState, setGetFetchParams] = useFetch(initialParams);

  return (
    <Grid container alignItems='center' justifyContent='center' spacing={1}>
      {getFetchState.loading ? (
        <CircularProgress />
      ) : getFetchState?.data?.data?.length > 0 ? (
        getFetchState?.data?.data?.map((valuation) => (
          <Grid item xs={12} style={{ borderBottom: "1px solid #75757522", marginBottom: 5 }}>
            <Grid container spacing={2} alignItems='center' justifyContent='center'>
              <Grid item xs={2}>
                <Typography noWrap>شناسه: {valuation?.id}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography noWrap>شناسه کل: {valuation?.full_id}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography noWrap>تاریخ: {jMoment(valuation?.date).format("jYYYY/jMM/jDD")}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography noWrap>آدرس: {valuation?.address}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography noWrap>ارزیاب: {valuation?.user?.work_title}</Typography>
              </Grid>
              <Grid item>
                <Link to={`../valuations/view/${valuation?.id}`} target={"_blank"} rel='noreferrer'>
                  <IconButton color='primary' size='small' fullWidth>
                    <OpenInBrowserOutlined />
                  </IconButton>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        ))
      ) : (
        <Fragment>
          <Chip label='ارزیابی با کد پستی مشابه پیدا نشد!' />
        </Fragment>
      )}
    </Grid>
  );
};

export default ValuationHistory;
